import { Drawer, Button, Grid, Form } from "antd";
import Swal from "sweetalert2"
import EmployeeForm from "./EmployeeForm";



const EmployeeQuickDrawer = ({ open, onClose, onCreated }) => {
  const screens = Grid.useBreakpoint();
  const [form] = Form.useForm();

  return (
    <Drawer
      open={open}
      title="Add Employee"
      width={screens.md ? 720 : "100%"}
      onClose={onClose}
      destroyOnHidden={true}
      styles={{
        body: {
          paddingInline: screens.md ? 40 : 20,
          paddingBottom: 88,
        },
        wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
      }}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
  type="primary"
  onClick={async () => {
    await Swal.fire({
      title: "Note",
      text:
        "To save the employee, please enable 'Map User' or " +
        "'Enable Login' from the Application Settings for User Mapping and Login panel.",
      icon: "info",
      confirmButtonText: "Continue",
    });

    // ✅ Proceed with actual save
    form.submit();
  }}
>
  Save
</Button>

        </div>
      }
    >
      <EmployeeForm
        mode="quick"
        form={form}
        onSuccess={onCreated}
        onClose={onClose}
      />
    </Drawer>
  );
};

export default EmployeeQuickDrawer;
